import { Col, Container, Row } from 'react-bootstrap';
import { IconClinicalTrials } from '@medifind/icons';
import { Skeleton } from '@medifind/shared-basic-components';
import ClinicalTrialRequest from './ClinicalTrialRequest/ClinicalTrialRequest';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialElement = ({ status, closestLocation, trialName, contacts }) => {
  return (
    <Container className={styles['clinical-trial-element__container']}>
      <Row style={{ marginBottom: '.5rem' }}>
        <Col>
          <IconClinicalTrials
            width={88}
            height={88}
            showBoxShadow={false}
            style={{
              width: '56px !important',
              minWidth: '56px !important',
              height: '56px !important',
              background: 'none !important',
            }}
          />
        </Col>
        <Col>
          <div className={styles['clinical-trial-element__text--top']}>
            {status ? 'Ready to take the next step?' : <Skeleton count={3} />}
          </div>
        </Col>
      </Row>
      {closestLocation && (
        <Row>
          <Col>
            {status ? (
              <ClinicalTrialRequest trialName={trialName} location={closestLocation ? closestLocation.address : null} contacts={contacts}>
                <div className={styles['clinical-trial-element__button']}>
                  <span className={styles['clinical-trial-element__button--text']}>Connect me to this trial</span>
                </div>
              </ClinicalTrialRequest>
            ) : (
              <Skeleton height={55} count={1} style={{ width: '100%' }} />
            )}
          </Col>
        </Row>
      )}
    </Container>
  );
};

export { ClinicalTrialElement as default, ClinicalTrialElement };
